var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavComponent'),_c('router-view'),_c('FooterComponent'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolltop",attrs:{"id":"kt_scrolltop","data-kt-scrolltop":"true"}},[_c('i',{staticClass:"ki-outline ki-arrow-up"})])
}]

export { render, staticRenderFns }